import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_ocr_doc_queue_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  insert_time: fromDatatype.TimestampTzDatatypeInterface;
  start_time: fromDatatype.TimestampTzDatatypeInterface;
  expire_time: fromDatatype.TimestampTzDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  event_properties: fromDatatype.JsonDatatypeInterface;
  number_of_retry: fromDatatype.NumericDatatypeInterface;
  max_retry: fromDatatype.NumericDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  processing_status: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_aat_claim_ocr_doc_queue_RowClass implements bl_aat_claim_ocr_doc_queue_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  insert_time: fromDatatype.TimestampTzDatatypeInterface;
  start_time: fromDatatype.TimestampTzDatatypeInterface;
  expire_time: fromDatatype.TimestampTzDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  event_properties: fromDatatype.JsonDatatypeInterface;
  number_of_retry: fromDatatype.NumericDatatypeInterface;
  max_retry: fromDatatype.NumericDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  processing_status: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
